import { DetailedHTMLProps, HTMLAttributes } from 'react';
import Image from 'next/image';
import cn from 'classnames';
import { AnimationOnScroll } from 'react-animation-on-scroll';

import styles from './lets-link-intro.module.css';

import bg from '../../public/letslink/intro/bg.jpg';
import map from '../../public/letslink/intro/map.png';
import phone from '../../public/letslink/intro/phone.png';
import { Container, Htag, HtagVariant, Paragraph } from '../../components';

export interface LetsLinkIntroProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {}

export default function LetsLinkIntro({
  className,
  ...props
}: LetsLinkIntroProps) {
  return (
    <section {...props} className={cn(className, styles.intro)}>
      <Image
        alt="Linkapp intro background"
        className={styles.background}
        src={bg}
        objectFit="contain"
        layout="fill"
      />
      <div className={styles.intro_bg}>
        <Container>
          <div className={styles.intro_inner}>
            <div className={styles.intro_start}>
              <AnimationOnScroll
                animateOnce
                duration={1.2}
                animateIn="animate__fadeInDown"
              >
                <Htag
                  tag="h1"
                  className={styles.intro_title}
                  variant={HtagVariant.h1}
                >
                  LinkApp
                </Htag>
              </AnimationOnScroll>
              <AnimationOnScroll
                animateOnce
                delay={500}
                duration={1.2}
                animateIn="animate__fadeInDown"
              >
                <Paragraph className={styles.intro_text}>
                  Resocializing Social Media that connects like-minded people.
                </Paragraph>
              </AnimationOnScroll>

              <div className={styles.intro_map}>
                <Image
                  alt="Linkapp map preview"
                  quality={70}
                  src={map}
                  width={586}
                  height={332}
                />
              </div>
            </div>
            <div className={styles.intro_end}>
              <Image alt="Linkapp phone preview" quality={70} src={phone} />
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
}
